module.exports = ".panel {\n    text-align: center;\n}\n\n.cert-message {\n    margin: 20px 0px\n}\n\n.cert-missing {\n    color: red;\n}\n\n.cert-save {\n    margin: 20px;\n}\n\n.content {\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n\n.dx-fieldset {\n    margin-bottom: 0px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cert-view/cert-view.component.css
// module id = ./src/app/components/cert-view/cert-view.component.css
// module chunks = main